import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { config, GameDataSource, GameService, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import * as _moment from 'moment';
import { CountdownModule } from '@fgb/portal-component-library/src/lib/shared/countdown';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@ngx-translate/core';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/shared/countdown';

function TicketTransferGamePanelComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "fgbcl-ticket-transfer-window-status-bar", 15);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("windowStartDate", ctx_r0.customerTicketSummary.WindowStartDate)("windowEndDate", ctx_r0.customerTicketSummary.WindowEndDate)("availableTransfers", ctx_r0.availableTransfers);
} }
function TicketTransferWindowStatusBarComponent_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "span", 5);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementStart(5, "span", 6);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 2, "cl.ticket.transfer.status.bar.not.open"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(7, 4, "cl.ticket.transfer.status.bar.not.open.bold"), "");
} }
function TicketTransferWindowStatusBarComponent_ng_container_0_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "span", 5);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementStart(5, "span", 6);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(4, 2, "cl.ticket.transfer.status.bar.closed"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 4, "cl.ticket.transfer.status.bar.closed.bold"));
} }
function TicketTransferWindowStatusBarComponent_ng_container_0_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2, "{{'cl.ticket.transfer.status.bar.no.available.tickets ");
    ɵngcc0.ɵɵelementStart(3, "span", 6);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 1, "cl.ticket.transfer.status.bar.no.available.tickets.bold"));
} }
function TicketTransferWindowStatusBarComponent_ng_container_0_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "span", 5);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "fgbcl-countdown", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, "cl.ticket.transfer.status.bar.open.window"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("endDateTime", ctx_r4.windowEndDate);
} }
const _c0 = function (a0, a1, a2, a3) { return { "bg-warning text-black": a0, "ticket-transfer-window-status-bar-closed": a1, "ticket-transfer-window-status-bar-not-open": a2, "ticket-transfer-window-status-bar-no-available-transfers": a3 }; };
function TicketTransferWindowStatusBarComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵtemplate(3, TicketTransferWindowStatusBarComponent_ng_container_0_div_3_Template, 8, 6, "div", 3);
    ɵngcc0.ɵɵtemplate(4, TicketTransferWindowStatusBarComponent_ng_container_0_div_4_Template, 8, 6, "div", 3);
    ɵngcc0.ɵɵtemplate(5, TicketTransferWindowStatusBarComponent_ng_container_0_div_5_Template, 6, 3, "div", 3);
    ɵngcc0.ɵɵtemplate(6, TicketTransferWindowStatusBarComponent_ng_container_0_div_6_Template, 6, 4, "div", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(5, _c0, ctx_r0.windowStatus() === "windowOpen", ctx_r0.windowStatus() === "windowClosed", ctx_r0.windowStatus() === "windowNotOpen", ctx_r0.windowStatus() === "noAvailableTransfers"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r0.windowStatus());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "windowNotOpen");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "windowClosed");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "noAvailableTransfers");
} }
const moment = _moment;
class TicketTransferGamePanelComponent {
    constructor(gameService, router) {
        this.gameService = gameService;
        this.router = router;
        this.pastGame = false;
        this.config = config;
    }
    ngOnInit() {
        if (this.customerTicketSummary.TicketsAvailableToTransfer === 0) {
            this.availableTransfers = false;
        }
        let currentDate = new Date();
        if (moment.utc(this.customerTicketSummary.Date) < moment.utc(currentDate)) {
            this.pastGame = true;
        }
    }
    selectGame(customerTicketSummary) {
        this.gameService.fetchGamesAndSetActiveGame(customerTicketSummary.GameNumber, GameDataSource.ExternalRef);
        this.router.navigate(['ticketTransfer/tickets/' + customerTicketSummary.GameNumber]);
    }
    getTeamLogoUrl(teamId) {
        return `${this.config.contentUrl}/image/teams/${teamId}__1_1_1033.png`;
    }
}
TicketTransferGamePanelComponent.ɵfac = function TicketTransferGamePanelComponent_Factory(t) { return new (t || TicketTransferGamePanelComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.GameService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router)); };
TicketTransferGamePanelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TicketTransferGamePanelComponent, selectors: [["fgbcl-ticket-transfer-game-panel"]], inputs: { customerTicketSummary: "customerTicketSummary" }, decls: 39, vars: 20, consts: [[1, "card", "mb-4"], [4, "ngIf"], [1, "card-body", "text-center", "bg-muted"], [1, "row"], [1, "col-2"], ["draggable", "false", 1, "img-fluid", 3, "src"], [1, "col-8"], [1, "d-flex", "justify-content-around"], [1, "font-weight-bold"], [1, "p-2", "text-center", "row"], [1, "col-6"], [1, "my-tickets-container"], [1, "forwarded-container"], [1, "ticket-transfer-panel-select-game", "font-weight-bold", "p-2", "w-90", "bg-primary", "align-self-center", "mb-3", 3, "click"], [1, "icon", "material-icons", "float-right"], [3, "windowStartDate", "windowEndDate", "availableTransfers"]], template: function TicketTransferGamePanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, TicketTransferGamePanelComponent_ng_container_1_Template, 2, 3, "ng-container", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelement(5, "img", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵelementStart(7, "div", 7);
        ɵngcc0.ɵɵelementStart(8, "p");
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "span", 8);
        ɵngcc0.ɵɵtext(11, "VS");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "p");
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 4);
        ɵngcc0.ɵɵelement(15, "img", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "p");
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵpipe(18, "date");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 9);
        ɵngcc0.ɵɵelementStart(20, "div", 10);
        ɵngcc0.ɵɵelementStart(21, "div", 11);
        ɵngcc0.ɵɵelementStart(22, "p");
        ɵngcc0.ɵɵtext(23);
        ɵngcc0.ɵɵpipe(24, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "span", 8);
        ɵngcc0.ɵɵtext(26);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(27, "div", 10);
        ɵngcc0.ɵɵelementStart(28, "div", 12);
        ɵngcc0.ɵɵelementStart(29, "p");
        ɵngcc0.ɵɵtext(30);
        ɵngcc0.ɵɵpipe(31, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "span", 8);
        ɵngcc0.ɵɵtext(33);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(34, "button", 13);
        ɵngcc0.ɵɵlistener("click", function TicketTransferGamePanelComponent_Template_button_click_34_listener() { return ctx.selectGame(ctx.customerTicketSummary); });
        ɵngcc0.ɵɵtext(35);
        ɵngcc0.ɵɵpipe(36, "translate");
        ɵngcc0.ɵɵelementStart(37, "span", 14);
        ɵngcc0.ɵɵtext(38, "chevron_right");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.pastGame === false);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.getTeamLogoUrl(ctx.customerTicketSummary.HomeTeamId), ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.customerTicketSummary.TeamNames.HomeTeamName);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.customerTicketSummary.TeamNames.AwayTeamName);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.getTeamLogoUrl(ctx.customerTicketSummary.AwayTeamId), ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(18, 11, ctx.customerTicketSummary.Date, "d MMM y HH:mm"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(24, 14, "cl.ticket.transfer.game.panel.tickets.available"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.customerTicketSummary.TicketsAvailableToTransfer);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(31, 16, "cl.ticket.transfer.game.panel.tickets.transferred"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.customerTicketSummary.TicketsTransferred);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(36, 18, "cl.ticket.transfer.game.panel.select.button.text"), " ");
    } }, directives: function () { return [ɵngcc3.NgIf, TicketTransferWindowStatusBarComponent]; }, pipes: function () { return [ɵngcc3.DatePipe, ɵngcc4.TranslatePipe]; }, styles: [""] });
TicketTransferGamePanelComponent.ctorParameters = () => [
    { type: GameService },
    { type: Router }
];
TicketTransferGamePanelComponent.propDecorators = {
    customerTicketSummary: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TicketTransferGamePanelComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-ticket-transfer-game-panel',
                template: "<div class=\"card mb-4\">\r\n  <ng-container *ngIf=\"pastGame === false\">\r\n    <fgbcl-ticket-transfer-window-status-bar\r\n      [windowStartDate]=\"customerTicketSummary.WindowStartDate\"\r\n      [windowEndDate]=\"customerTicketSummary.WindowEndDate\"\r\n      [availableTransfers]=\"availableTransfers\"\r\n    ></fgbcl-ticket-transfer-window-status-bar>\r\n  </ng-container>\r\n  <div class=\"card-body text-center bg-muted\">\r\n    <div class=\"row\">\r\n      <div class=\"col-2\">\r\n        <img src=\"{{ getTeamLogoUrl(customerTicketSummary.HomeTeamId) }}\" draggable=\"false\" class=\"img-fluid\" />\r\n      </div>\r\n      <div class=\"col-8\">\r\n        <div class=\"d-flex justify-content-around\">\r\n          <p>{{ customerTicketSummary.TeamNames.HomeTeamName }}</p>\r\n          <span class=\"font-weight-bold\">VS</span>\r\n          <p>{{ customerTicketSummary.TeamNames.AwayTeamName }}</p>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-2\">\r\n        <img src=\"{{ getTeamLogoUrl(customerTicketSummary.AwayTeamId) }}\" draggable=\"false\" class=\"img-fluid\" />\r\n      </div>\r\n    </div>\r\n    <p>{{ customerTicketSummary.Date | date: 'd MMM y HH:mm' }}</p>\r\n  </div>\r\n\r\n  <div class=\"p-2 text-center row\">\r\n    <div class=\"col-6\">\r\n      <div class=\"my-tickets-container\">\r\n        <p>{{ 'cl.ticket.transfer.game.panel.tickets.available' | translate }}</p>\r\n        <span class=\"font-weight-bold\">{{ customerTicketSummary.TicketsAvailableToTransfer }}</span>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-6\">\r\n      <div class=\"forwarded-container\">\r\n        <p>{{ 'cl.ticket.transfer.game.panel.tickets.transferred' | translate }}</p>\r\n        <span class=\"font-weight-bold\">{{ customerTicketSummary.TicketsTransferred }}</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <button\r\n    class=\"ticket-transfer-panel-select-game font-weight-bold p-2 w-90 bg-primary align-self-center mb-3\"\r\n    (click)=\"selectGame(customerTicketSummary)\"\r\n  >\r\n    {{ 'cl.ticket.transfer.game.panel.select.button.text' | translate }}\r\n    <span class=\"icon material-icons float-right\">chevron_right</span>\r\n  </button>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.GameService }, { type: ɵngcc2.Router }]; }, { customerTicketSummary: [{
            type: Input
        }] }); })();

const moment$1 = _moment;
class TicketTransferWindowStatusBarComponent {
    constructor() { }
    ngOnInit() {
    }
    windowStatus() {
        if (this.availableTransfers === false) {
            return 'noAvailableTransfers';
        }
        if (moment$1.utc(this.windowEndDate).isBefore(moment$1.utc())) {
            return 'windowClosed';
        }
        else if (moment$1.utc(this.windowStartDate).isAfter(moment$1.utc())) {
            return 'windowNotOpen';
        }
        else {
            return 'windowOpen';
        }
    }
}
TicketTransferWindowStatusBarComponent.ɵfac = function TicketTransferWindowStatusBarComponent_Factory(t) { return new (t || TicketTransferWindowStatusBarComponent)(); };
TicketTransferWindowStatusBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TicketTransferWindowStatusBarComponent, selectors: [["fgbcl-ticket-transfer-window-status-bar"]], inputs: { windowStartDate: "windowStartDate", windowEndDate: "windowEndDate", availableTransfers: "availableTransfers" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "transfer-window", "text-center", "p-2", 3, "ngClass"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [1, "icon-timer-1", "ticket-transfer-window-status-bar-icon"], [1, "font-weight-bold"], [3, "endDateTime"]], template: function TicketTransferWindowStatusBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TicketTransferWindowStatusBarComponent_ng_container_0_Template, 7, 10, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.windowStartDate && ctx.windowEndDate);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgClass, ɵngcc3.NgSwitch, ɵngcc3.NgSwitchCase, ɵngcc3.NgSwitchDefault, ɵngcc5.CountdownComponent], pipes: [ɵngcc4.TranslatePipe], styles: [".transfer-window[_ngcontent-%COMP%]{border-top-left-radius:5px;border-top-right-radius:5px;font-size:12px}.teams-information-container[_ngcontent-%COMP%]{margin-bottom:5px}"] });
TicketTransferWindowStatusBarComponent.ctorParameters = () => [];
TicketTransferWindowStatusBarComponent.propDecorators = {
    windowStartDate: [{ type: Input }],
    windowEndDate: [{ type: Input }],
    availableTransfers: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TicketTransferWindowStatusBarComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-ticket-transfer-window-status-bar',
                template: "<ng-container *ngIf=\"windowStartDate && windowEndDate;\">\r\n  <div\r\n    class=\"transfer-window text-center p-2\"\r\n    [ngClass]=\"{\r\n      'bg-warning text-black': windowStatus() === 'windowOpen',\r\n      'ticket-transfer-window-status-bar-closed': windowStatus() === 'windowClosed',\r\n      'ticket-transfer-window-status-bar-not-open': windowStatus() === 'windowNotOpen',\r\n      'ticket-transfer-window-status-bar-no-available-transfers': windowStatus() === 'noAvailableTransfers'\r\n    }\"\r\n  >\r\n    <div [ngSwitch]=\"windowStatus()\">\r\n      <div *ngSwitchCase=\"'windowNotOpen'\">\r\n        <span class=\"icon-timer-1 ticket-transfer-window-status-bar-icon\"></span>\r\n        <span> {{ 'cl.ticket.transfer.status.bar.not.open' | translate }} \r\n        <span class=\"font-weight-bold\"> {{ 'cl.ticket.transfer.status.bar.not.open.bold' | translate }}</span></span>\r\n      </div>\r\n      <div *ngSwitchCase=\"'windowClosed'\">\r\n        <span class=\"icon-timer-1 ticket-transfer-window-status-bar-icon\"></span>\r\n        <span>{{ 'cl.ticket.transfer.status.bar.closed' | translate }} \r\n          <span class=\"font-weight-bold\">{{ 'cl.ticket.transfer.status.bar.closed.bold' | translate }}</span></span>\r\n      </div>\r\n      <div *ngSwitchCase=\"'noAvailableTransfers'\">\r\n        <span>{{'cl.ticket.transfer.status.bar.no.available.tickets \r\n          <span class=\"font-weight-bold\">{{ 'cl.ticket.transfer.status.bar.no.available.tickets.bold' | translate }}</span></span>\r\n      </div>\r\n      <div *ngSwitchDefault>\r\n        <span class=\"icon-timer-1 ticket-transfer-window-status-bar-icon\"></span>\r\n        <span>{{'cl.ticket.transfer.status.bar.open.window' | translate }}</span>\r\n        <fgbcl-countdown [endDateTime]=\"windowEndDate\"></fgbcl-countdown>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n",
                styles: [".transfer-window{border-top-left-radius:5px;border-top-right-radius:5px;font-size:12px}.teams-information-container{margin-bottom:5px}"]
            }]
    }], function () { return []; }, { windowStartDate: [{
            type: Input
        }], windowEndDate: [{
            type: Input
        }], availableTransfers: [{
            type: Input
        }] }); })();

class TicketTransferGamePanelModule {
}
TicketTransferGamePanelModule.ɵfac = function TicketTransferGamePanelModule_Factory(t) { return new (t || TicketTransferGamePanelModule)(); };
TicketTransferGamePanelModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TicketTransferGamePanelModule });
TicketTransferGamePanelModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            CountdownModule,
            PipesModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TicketTransferGamePanelModule, { declarations: function () { return [TicketTransferGamePanelComponent, TicketTransferWindowStatusBarComponent]; }, imports: function () { return [CommonModule,
        CountdownModule,
        PipesModule, ɵngcc4.TranslateModule]; }, exports: function () { return [TicketTransferGamePanelComponent, TicketTransferWindowStatusBarComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TicketTransferGamePanelModule, [{
        type: NgModule,
        args: [{
                declarations: [TicketTransferGamePanelComponent, TicketTransferWindowStatusBarComponent],
                imports: [
                    CommonModule,
                    CountdownModule,
                    PipesModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [TicketTransferGamePanelComponent, TicketTransferWindowStatusBarComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TicketTransferGamePanelComponent, TicketTransferGamePanelModule, TicketTransferWindowStatusBarComponent };

//# sourceMappingURL=fgb-portal-component-library-src-lib-tickettransfer-ticket-transfer-game-panel.js.map